// Basic profanity filter — add/remove words as needed
const BANNED = [
  'fuck','shit','ass','bitch','cunt','dick','cock','pussy','bastard',
  'damn','hell','crap','piss','twat','nigger','faggot','retard','slut','whore'
]

const BAD_PATTERNS = BANNED.map(w => new RegExp(`\\b${w}\\b`, 'i'))

export function containsProfanity(text) {
  if (!text) return false
  return BAD_PATTERNS.some(p => p.test(text))
}

export function cleanText(text) {
  if (!text) return text
  let cleaned = text
  BAD_PATTERNS.forEach((p, i) => {
    cleaned = cleaned.replace(p, '*'.repeat(BANNED[i].length))
  })
  return cleaned
}

export function flagFields(obj) {
  // Returns true if any string field contains profanity
  return Object.values(obj).some(v => typeof v === 'string' && containsProfanity(v))
}
